import { findKey } from 'lodash';

export function getNextOverlay(state) {
    /**
     * Get the next item in line
     * @param {string} hashId
     * @return {IPaymentMethodListItem|null}
     */
    return (hashId) => {
        const currentIndex = parseInt(findKey(state.items, { hash_id: hashId }));
        if (currentIndex !== -1 && state.items[currentIndex + 1]) {
            return state.items[currentIndex + 1];
        }
        return null;
    };
}


export function getPrevOverlay(state) {
    /**
     * Get the previous item in line
     * @param {string} hashId
     * @return {IPaymentMethodListItem|null}
     */
    return (hashId) => {
        const currentIndex = parseInt(findKey(state.items, { hash_id: hashId }));
        if (currentIndex !== -1 && state.items[currentIndex - 1]) {
            return state.items[currentIndex - 1];
        }
        return null;
    };
}
